import React, { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Form } from '@ant-design/compatible';
import ScrollToTop from '../../components/ScrollToTop';
import { PAGE_TAB_TITLE_LIST } from '../../constants/service/common/pageConstants';
import LandingWrap from '../../views/login/FormWrap';
import * as PATHS from '../../constants/service/common/urlConstants';
import { useAuth } from '../../hooks/common/useAuth';

const LoginFormContainer = (props) => {
  const { form } = props;
  const { login } = useAuth();
  const [authData, setAuthData] = useState({
    email: null,
    password: null,
  });

  /**
   *  데이터 변경
   */
  const setData = (data) => {
    setAuthData({
      ...authData,
      [data.name]: data.value,
    });
  };
  /**
   *  로그인하기
   */
  const onLogin = () => {
    form.validateFields((err) => {
      if (err) return;
      login(authData);
    });
  };

  return (
    <Fragment>
      {/********** 페이지의 탭 타이틀 **********/}
      <Helmet>
        <title>{PAGE_TAB_TITLE_LIST[PATHS.LOGIN_URL_PATH]}</title>
      </Helmet>
      <ScrollToTop />
      <LandingWrap form={form} authData={authData} setData={setData} onLogin={onLogin} />
    </Fragment>
  );
};

export default Form.create()(LoginFormContainer);
